import { Box, List, ListItem, Stack, Typography } from '@mui/material';
import section8_image from 'assets/img/ECommerce/section8_image.png';
import AnimatedButton from 'components/common/AnimatedButton';
import React, { JSX } from 'react';
import { E_COMMERCE_STYLES } from './config';
import { paths } from 'routes/routes/paths';
import { Link } from 'react-router-dom';

export default function Section8(): JSX.Element {
  return (
    <>
      <Box sx={{ px: 2, py: 6 }}>
        <Stack
          spacing={3}
          maxWidth={E_COMMERCE_STYLES.container.maxWidth}
          mx={E_COMMERCE_STYLES.container.mx}
        >
          <Typography variant="h3" color="black" className="font-helvetica-bold">
            Leverage Customer Psychology at Every Click
          </Typography>
          <Typography
            variant="h4"
            fontSize={22}
            maxWidth={'90%'}
            color="black"
            className="font-helvetica-light"
          >
            Your website isn’t just a digital store — it’s your 24/7 sales hero. To convert
            consistently, it must guide users through a journey designed around human behavior — how
            people think, feel, hesitate, and decide.
          </Typography>
          <Box
            component="img"
            src={section8_image}
            alt="hero"
            sx={{
              width: '100%',
              borderRadius: 2,
            }}
          />
        </Stack>
      </Box>
      <Box
        pb={6}
        sx={{
          background: 'linear-gradient(to bottom, #daeaf925, #e0efffff)',
        }}
      >
        <Box
          sx={{ p: 4, py: 2, borderRadius: 2 }}
          maxWidth={E_COMMERCE_STYLES.container.maxWidth}
          mx={E_COMMERCE_STYLES.container.mx}
        >
          <Typography color="text.black" variant="subtitle2" className="font-helvetica-bold">
            Understand Their Journey :
          </Typography>
          <Typography
            color="text.black"
            variant="subtitle2"
            fontSize={13}
            className="font-helvetica"
          >
            Map each stage — from first glance to final checkout — with psychological triggers that
            match intent.
          </Typography>

          <List sx={{ listStyle: 'disc', pl: 3 }}>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
              <Typography
                color="text.black"
                variant="caption"
                fontSize={13}
                className="font-helvetica-bold"
              >
                Set the Right Offer :
              </Typography>
              <br />
              <Typography
                color="text.black"
                variant="subtitle2"
                fontSize={13}
                className="font-helvetica"
              >
                Position your value so clearly that visitors don’t compare — they convert.
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
              <Typography
                color="text.black"
                variant="caption"
                fontSize={13}
                className="font-helvetica-bold"
              >
                Handle Objections Before They’re Asked :
              </Typography>
              <br />
              <Typography
                color="text.black"
                variant="subtitle2"
                fontSize={13}
                className="font-helvetica"
              >
                Through design, microcopy, and trust signals, we address doubts before they arise.
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
              <Typography
                color="text.black"
                variant="caption"
                fontSize={13}
                className="font-helvetica-bold"
              >
                Highlight What Makes You Different:
              </Typography>
              <br />
              <Typography
                color="text.black"
                variant="subtitle2"
                fontSize={13}
                className="font-helvetica"
              >
                Showcase your USP where it matters — when attention is highest, and decision is
                near.
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 1 }}>
              <Typography
                color="text.black"
                variant="caption"
                fontSize={13}
                className="font-helvetica-bold"
              >
                Design That Thinks Like a Salesperson:
              </Typography>
              <br />
              <Typography
                color="text.black"
                variant="subtitle2"
                fontSize={13}
                className="font-helvetica"
              >
                Pages built to guide, convince, and close — like your best sales rep, working 24×7.
              </Typography>
            </ListItem>
          </List>
        </Box>

        <Box
          sx={{ p: 4, borderRadius: 2 }}
          maxWidth={E_COMMERCE_STYLES.container.maxWidth}
          mx={E_COMMERCE_STYLES.container.mx}
        >
          <Typography color="text.black" variant="h6" className="font-helvetica-bold">
            Lower bounce rates.
            <br /> Higher conversion rates.
          </Typography>

          <List sx={{ listStyle: 'disc', pl: 3, mb: 2 }}>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 0 }}>
              <Typography
                color="text.black"
                variant="subtitle2"
                fontSize={13}
                className="font-helvetica"
              >
                Lower bounce through intuitive, psychology ‑ backed navigation
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0, mb: 0 }}>
              <Typography
                color="text.black"
                variant="subtitle2"
                fontSize={13}
                className="font-helvetica"
              >
                Improved conversion with behavior‑driven CTAs and flow
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'list-item', p: 0 }}>
              <Typography
                color="text.black"
                variant="subtitle2"
                fontSize={13}
                className="font-helvetica"
              >
                Tailored for how your audience browses — not just how it looks
              </Typography>
            </ListItem>
          </List>

          <Link to={paths.public.schedule}>
            <AnimatedButton
              label={
                <Typography variant="button" className="font-helvetica-bold" lineHeight={'17px'}>
                  How Customer Psychology Drives Performance
                </Typography>
              }
              sx={{
                textAlign: 'start',
                minHeight: '57px',
              }}
            />
          </Link>

          <Typography
            mt={1}
            maxWidth={'80%'}
            variant="body2"
            color="#676767"
            className="font-serif"
          >
            Discuss in details through a scheduled Google Meet.
          </Typography>
        </Box>
      </Box>
    </>
  );
}
